import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetUserWithRoles } from "src/app/store/user-access/user-access.action";

export function UserAccessResolver() {
    return inject(Store).dispatch(new GetUserWithRoles());
}